module.exports = __webpack_public_path__ + "img/wave.49e20aad.svg";